// import { configureStore } from "@reduxjs/toolkit";
// import userReducer from "./slices/userSlice";
// // import tourReducer from "./slices/tourSlice";
// // import taxiReducer from "./slices/taxiSlice";

// const store = configureStore({
//   reducer: {
//     user: userReducer,
//     // tour: tourReducer,
//     // taxi: taxiReducer,
//   },
// });

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Uses localStorage
import { persistStore, persistReducer } from "redux-persist";
import userReducer from "./slices/userSlice";
import packageReducer from "./slices/packageSlice"; 
import pickupLocationReducer from './slices/pickupLocationSlice';
import bookingReducer  from './slices/bookingSlice';
// import tourReducer from "./slices/tourSlice";
// import taxiReducer from "./slices/taxiSlice";

// Configuration for persisting the `user` slice
const userPersistConfig = {
  key: "user",
  storage,
};
const packagePersistConfig = {
  key: "package",
  storage,
};


// Persisted reducer for user
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedPackageReducer = persistReducer(packagePersistConfig, packageReducer);


const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    package: persistedPackageReducer,
    pickupLocation: pickupLocationReducer, 
    bookingConfirm:bookingReducer
    // tour: tourReducer,
    // taxi: taxiReducer,
  },
});

export const persistor = persistStore(store); // Creates a persistor instance

export default store;

